import React, { Component } from "react";

import EditorPicks from "./editorpicks";

class EditorPicksComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <div>
        <EditorPicks api={this.props} />
      </div>
    );
  }
}

export default EditorPicksComponent;
